import { useMemo } from 'react';

import cleanRedirectUrl from '~/utils/cleanRedirectUrl';

interface Props {
  value?: string;
  redirectToHome?: boolean;
}

const RedirectToHiddenInput = ({ value, redirectToHome = false }: Props) => {
  const defaultValue = useMemo(() => {
    if (typeof window === 'undefined') return '';

    let url = window.location.origin;

    if (redirectToHome) {
      url = `${url}`;
    }

    return cleanRedirectUrl(window.location.href);
  }, [redirectToHome]);

  return <input type="hidden" name="redirect_to" value={value || defaultValue} />;
};

export default RedirectToHiddenInput;
